var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "side-menu" },
    [
      _c("div", { staticClass: "site-name" }, [
        _c("div", { staticClass: "img-wrap" }, [_c("Logo")], 1),
        _c("span", { staticClass: "company-name" }, [
          _vm._v(_vm._s(_vm.companyName)),
        ]),
      ]),
      _c(
        "el-scrollbar",
        { staticClass: "side-menu-inner", attrs: { tag: "div" } },
        _vm._l(_vm.tree, function (menu, index) {
          return _c(
            "div",
            { key: menu.Guid },
            [
              menu.Children.length > 0
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "has-sub-menu-inner",
                        class: {
                          "sub-menu-open": menu.open,
                          "has-sub-menu": menu.Children.length > 0,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.collapseMenu(index)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                _vm.menuCategory = "parents"
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "icon-wrap" },
                              [
                                _vm.icon
                                  ? _c("eva-icon", {
                                      attrs: {
                                        name: _vm.icon[index],
                                        fill: "#FFF",
                                        width: "18",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            menu.LocalizationalMenus.length > 0
                              ? _c(
                                  "span",
                                  [
                                    _vm._l(
                                      menu.LocalizationalMenus,
                                      function (language) {
                                        return [
                                          language.LocalizationTypeCode ===
                                          _vm.currentLanguage
                                            ? _c(
                                                "span",
                                                {
                                                  key: language.LocalizationTypeGuid,
                                                  staticStyle: {
                                                    color: "#fff",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        language.MenuName
                                                          ? language.MenuName
                                                          : menu.MenuName
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _c("span", [
                                  _vm._v(" " + _vm._s(menu.MenuName) + " "),
                                ]),
                          ]
                        ),
                        _c(
                          "ul",
                          _vm._l(menu.Children, function (subMenu) {
                            return _c(
                              "li",
                              {
                                key: subMenu.Guid,
                                on: {
                                  click: function ($event) {
                                    _vm.menuCategory = "children"
                                  },
                                },
                              },
                              [
                                subMenu.ExternalLink
                                  ? [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: subMenu.Link,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._l(
                                            subMenu.LocalizationalMenus,
                                            function (language) {
                                              return [
                                                language.LocalizationTypeCode ===
                                                _vm.currentLanguage
                                                  ? _c(
                                                      "span",
                                                      {
                                                        key: language.LocalizationTypeGuid,
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              language.MenuName
                                                                ? language.MenuName
                                                                : subMenu.MenuName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  : [
                                      !subMenu.NewWindow
                                        ? _c(
                                            "router-link",
                                            { attrs: { to: subMenu.Link } },
                                            [
                                              subMenu.LocalizationalMenus
                                                .length > 0
                                                ? _c(
                                                    "div",
                                                    [
                                                      _vm._l(
                                                        subMenu.LocalizationalMenus,
                                                        function (language) {
                                                          return [
                                                            language.LocalizationTypeCode ===
                                                            _vm.currentLanguage
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    key: language.LocalizationTypeGuid,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          language.MenuName
                                                                            ? language.MenuName
                                                                            : subMenu.MenuName
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          subMenu.MenuName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                            ]
                                          )
                                        : _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: `${_vm.url}/#${subMenu.Link}`,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              subMenu.LocalizationalMenus
                                                .length > 0
                                                ? _c(
                                                    "div",
                                                    [
                                                      _vm._l(
                                                        subMenu.LocalizationalMenus,
                                                        function (language) {
                                                          return [
                                                            language.LocalizationTypeCode ===
                                                            _vm.currentLanguage
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    key: language.LocalizationTypeGuid,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          language.MenuName
                                                                            ? language.MenuName
                                                                            : subMenu.MenuName
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          subMenu.MenuName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                    ],
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }